import { ApiRequestOptions } from '@api/core/ApiRequestOptions';
import { getRequestOptions } from '@api/core/utils';

import type { TourSearchViewModel } from '../models/TourSearchViewModel';
import type { CancelablePromise } from '../core/CancelablePromise';
import { request as __request } from '../core/request';

export class CruisesService {
  /**
   * Search
   * Searches cruises
   * @returns TourSearchViewModel Success
   * @throws ApiError
   */
  public static async searchCruise(
    {
      s,
    }: {
      /**
       * Search terms
       */
      s: string;
    },
    options?: Partial<ApiRequestOptions>
  ): CancelablePromise<Array<TourSearchViewModel>> {
    const { cookies = {}, headers = {} } = options ?? {};
    delete cookies.token;
    const result = await __request<Array<TourSearchViewModel>>({
      method: 'GET',
      url: `/cruises/search`,
      query: {
        ...(s ? { s: s } : {}),
      },
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
        500: `Server Error`,
      },
      headers: getRequestOptions(headers, 'headers'),
      cookies: { ...getRequestOptions(cookies, 'cookies') },
    });
    return result;
  }
}
